import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AggregateResult } from '../../../api/types/analytics';
import { regionName } from './format';
import { Banner, Card, SectionTitle } from './styles';

interface Props {
  title: string;
  result?: AggregateResult<unknown>;
  loading: boolean;
  children: React.ReactNode;
}

/** Failed requests are distinct from a successful response containing no records. */
const SectionState: FC<Props> = ({ title, result, loading, children }) => {
  const [t] = useTranslation();
  if (loading || !result?.failedRegions.length) return <>{children}</>;

  const notices = result.failedRegions.map((failure) => (
    <Banner key={failure.region} $tone="warning" role="alert">
      {failure.status === 403
        ? t('DD_SECTION_FORBIDDEN', { section: title, region: regionName(failure.region) })
        : t('DD_SECTION_FAILED', {
            section: title,
            region: regionName(failure.region),
            reason: failure.status ? `HTTP ${failure.status}` : t('DD_REQUEST_UNAVAILABLE'),
          })}
    </Banner>
  ));

  if (!result.okRegions.length) {
    return <Card><SectionTitle>{title}</SectionTitle>{notices}</Card>;
  }
  return <div style={{ minWidth: 0 }}>{notices}{children}</div>;
};

export default SectionState;
